import { NgModule } from '@angular/core';
import { FaqImagePanelItemComponent } from './faq-image-panel-item.component';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/shared/shared.module';

@NgModule({
    imports: [CommonModule, SharedModule],
    exports: [FaqImagePanelItemComponent],
    declarations: [FaqImagePanelItemComponent],
})
export class FaqImagePanelItemModule { }
